import { render, staticRenderFns } from "./TopicoSalaAulaInterno.vue?vue&type=template&id=680e6f5d&scoped=true&"
import script from "./TopicoSalaAulaInterno.vue?vue&type=script&lang=js&"
export * from "./TopicoSalaAulaInterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680e6f5d",
  null
  
)

export default component.exports